import { Link } from "react-router-dom";
import { HomeContainer } from "./stylesHomePageDisplay";
import HomePageMainImage from './components/HomePageMainImage/HomePageMainImage';
import marketPicture from '../../assets/market1.jpg';
import FeaturesDisplay from "./components/FeaturesDisplay/FeaturesDisplay";
import Banner from "./components/Banner/Banner ";
import adImage from '../../assets/market3.jpg';

export default function HomePageDisplay() {

    return (
        <>
                <HomePageMainImage image={marketPicture} title={"Fazer mercado nunca foi tão fácil"}  />
            <HomeContainer>
                <h2>Bem-vindo{`(a)`} ao seu assistente de compras!</h2>
                <p>Aqui você poderá criar suas listas, comparar os preços e nunca esquecer de levar tudo que precisa. <br></br> Vamos começar? </p> 
                <Link to='/minhas-listas'>Clique aqui para ver suas listas</Link>
            </HomeContainer>
                <hr/>
            <FeaturesDisplay />
            <Banner image={adImage} text={"Compre com inteligência e facilidade. Economia garantida!"} />
            <HomeContainer>
                <h2>Não perca tempo!</h2>
                <p>Venha fazer parte dessa ideia</p>
                <Link to='/register'>Crie sua conta aqui</Link>
            </HomeContainer>
        </>
    );
}